import React from 'react';
// Logo ta import korchi. Kheyal rakhish path-ta jeno thik thake.
import logo from '../logo.jpeg'; 

function Navbar() {
  return (
    <nav className="sticky top-0 z-50 bg-white/75 backdrop-blur-lg border-b border-gray-100 py-4 px-6 md:px-16 lg:px-24 flex justify-between items-center shadow-sm">
      
      {/* Logo & Name Section */}
      <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo(0,0)}>
        {/* Bikhyato Logo */}
        <img 
          src={logo} 
          alt="Parinita Dutta Roy Logo" 
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover shadow-sm border border-gray-100 hover:scale-105 transition-transform" 
        />
        {/* Name Text */}
        <div className="text-xl md:text-2xl font-serif font-black tracking-tighter text-deep-charcoal uppercase">
          Parinita Dutta Roy
        </div>
      </div>

      {/* Navigation Links Section */}
      <div className="hidden md:flex items-center space-x-10">
        <a href="#home" className="text-sm font-bold uppercase tracking-widest text-deep-charcoal/80 hover:text-ocean-teal transition-colors">Home</a>
        <a href="#videos" className="text-sm font-bold uppercase tracking-widest text-deep-charcoal/80 hover:text-ocean-teal transition-colors">Videos</a>
        <a href="#booking" className="bg-ocean-teal text-white px-7 py-3 rounded-full text-sm font-bold hover:bg-ocean-teal/90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 active:translate-y-0">
          Book Appointment
        </a>
      </div>
    </nav>
  );
}

export default Navbar;